import _ from "lodash";
import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";

import actions from "@/actions";
import { Machine } from "@/sx-layout/components/plotmap/models";

const MIN_SIZE = 0.5;
const MAX_SIZE = 2;
const STEP = 0.1;

export const useChangeMachineSize = (machine: Machine, onChangeSize: (m: Machine) => void) => {
  const dispatch = useDispatch();

  const [size, setSize] = useState<number>(machine.size);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    setSize(machine.size);
  }, [machine.machine_id]);

  // 重機更新
  const updateMachine = (value: number, m: Machine) => {
    setIsLoading(true);
    dispatch(
      actions.machineEdit.updateMachine({
        input: {
          ...m,
          files: [],
          size: value,
        },
        onSuccess: (data: Machine) => {
          onChangeSize(data);
          setIsLoading(false);
        },
        onFailure: () => {
          setIsLoading(false);
        },
      })
    );
  };

  // サイズ変更
  const debounceUpdateMachine = useMemo(() => _.debounce(updateMachine, 300), []);
  const decrease = () => {
    if (size <= MIN_SIZE || isLoading) return;

    const newSize = round(size - STEP);
    setSize(newSize);
    debounceUpdateMachine(newSize, machine);
  };
  const increase = () => {
    if (MAX_SIZE <= size || isLoading) return;

    const newSize = round(size + STEP);
    setSize(newSize);
    debounceUpdateMachine(newSize, machine);
  };

  // 丸め処理
  const round = (value: number): number => {
    const factor = Math.pow(10, 1);
    return Math.round(value * factor) / factor;
  };

  return {
    size,
    decrease,
    increase,
    isLoading,
  };
};
